import { Box } from "@chakra-ui/react"
import { Button, Text } from "@/components/ui"

interface Props {
  handleMicrosoftLogin: () => Promise<void>;
  isLoading: boolean;
  loginError?: string | null;
}

export const SignInComponent = ({ handleMicrosoftLogin, isLoading, loginError }: Props) => {
  return (
    <Box w="55%" zIndex={1} bg="card.bg" p={10} borderRadius={10} boxShadow="lg" minW="300px">
      <Text fontSize="3xl" fontWeight="semibold" mb={6}>
        Log into your account
      </Text>
      <Box pl={5} pr={5}>
        <Button
          colorScheme="blue"
          variant="solid"
          w="full"
          mb={loginError ? 3 : 6}
          onClick={handleMicrosoftLogin}
          loading={isLoading}
        >
          Sign in with Microsoft
        </Button>
        {loginError && (
          <Text color="red.500" fontSize="sm" mb={3} textAlign="center">
            {loginError}
          </Text>
        )}
      </Box>
    </Box>
  )
}
